import { createSlice, type PayloadAction } from "@reduxjs/toolkit";

import { type Auth } from "./state";
import { actions as userActions } from "./userSlice";

/** @deprecated We are phasing out `redux` */
export const initialState: Auth = {
  identifier: "",
  isLoading: false,
  token: null,
};

/** @deprecated We are phasing out `redux` */
const slice = createSlice({
  extraReducers: (builder) =>
    builder.addCase(userActions.logout, (state) => {
      state.identifier = initialState.identifier;
      state.token = initialState.token;
    }),
  initialState,
  name: "auth",
  reducers: {
    loginFailed(state) {
      state.isLoading = false;
    },
    loginRequested(state) {
      state.isLoading = true;
    },
    loginSuccess(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.identifier = action.payload;
    },
    verifySuccess(state, action: PayloadAction<string>) {
      state.isLoading = false;
      state.token = action.payload;
    },
  },
});

/** @deprecated We are phasing out `redux` */
export const actions = slice.actions;
/** @deprecated We are phasing out `redux` */
export default slice.reducer;
